import { createContext, useContext, useReducer } from 'react';
import ajaxVoucher from '../util/remote/ajaxVoucher';

const initialState = { 
  revenueTrends: null,
  revenueCharts: null,
  popularPlansChart: null,
  userMetrics: null
};

const reducer = (state, action) => {
    switch (action.type) {
      case 'CLEAR':
        return { initialState};  // Reset state completely
      default:
        return {...state, [action.type]: action.payload};
    }
  };


const StatContext = createContext();

export const StatProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);

  const getRevenueTrends = async (refresh = false) => {
    if(!refresh && state.revenueTrends) return;
    const server_response  = await ajaxVoucher.fetchRevenueTrends();
    if(server_response.status === "OK"){
        dispatch({ type: 'revenueTrends', payload: server_response.details });
    }
  };

  const getRevenueCharts = async (refresh = false) => {
    if(!refresh && state.revenueCharts) return;
    const server_response  = await ajaxVoucher.fetchRevenueCharts();
    if(server_response.status === "OK"){
        dispatch({ type: 'revenueCharts', payload: server_response.details });
    }
  };

  const getPopularPlansChart = async (refresh = false) => {
    if(!refresh && state.popularPlansChart) return;
    const server_response  = await ajaxVoucher.fetchPopularPlansChart();
    if(server_response.status === "OK"){
        dispatch({ type: 'popularPlansChart', payload: server_response.details });
    }
  };

  const getUserMetrics = async (refresh = false) => {
    if(!refresh && state.userMetrics) return;
    const server_response  = await ajaxVoucher.fetchUserMetrics();
    if(server_response.status === "OK"){
        dispatch({ type: 'userMetrics', payload: server_response.details });
    }
  };

  return(
    <StatContext.Provider value={{
      ...state, 
      dispatch, 
      getRevenueTrends,
      getRevenueCharts,
      getPopularPlansChart,
      getUserMetrics
      }}>
      {children}
    </StatContext.Provider>
  )

}

export const useStat = ()=>useContext(StatContext);

